import React from "react";

import "./ProgressBar.scss";

interface ProgressBarProps {
    progress: number;
    className?: string;
}

class ProgressBar extends React.Component<ProgressBarProps> {
    render(): React.ReactNode {
        let classNames = "progress-bar";

        if (this.props.className) {
            classNames += ` ${this.props.className}`;
        }

        return (
            <div className={classNames}>
                <div
                    className="progress-bar-progress"
                    style={{
                        width: `${this.props.progress}%`,
                    }}></div>
            </div>
        );
    }
}

export default ProgressBar;
